import { fetchPayload, fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

import {
  publishers,
  brands,
  keywords,
  partnerships,
  categories,
  content,
} from 'api';

import {
  FETCH_CATEGORIES_LIST, FETCHED_CATEGORIES_LIST,
  FETCH_KEYWORDS_LIST, FETCHED_KEYWORDS_LIST,
 } from 'components/Global/Filters/actions.js';

export const FETCH_PARTNERSHIP_METADATA = 'FETCH_PARTNERSHIP_METADATA';
export const FETCHED_PARTNERSHIP_METADATA = 'FETCHED_PARTNERSHIP_METADATA';

export const FETCH_PARTNERSHIP_CONTENT = 'FETCH_PARTNERSHIP_CONTENT';
export const FETCHED_PARTNERSHIP_CONTENT = 'FETCHED_PARTNERSHIP_CONTENT';
export const SET_PARTNERSHIP_CONTENT_FILTER = 'SET_PARTNERSHIP_CONTENT_FILTER';

export const FETCH_BRAND_PARTNERSHIPS = 'FETCH_BRAND_PARTNERSHIPS';
export const FETCHED_BRAND_PARTNERSHIPS = 'FETCHED_BRAND_PARTNERSHIPS';

export const FETCH_PUBLISHER_PARTNERSHIPS = 'FETCH_PUBLISHER_PARTNERSHIPS';
export const FETCHED_PUBLISHER_PARTNERSHIPS = 'FETCHED_PUBLISHER_PARTNERSHIPS';


export const fetchPartnershipList = (clear, entityId, entityType) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: entityType === 'brand' ? getState().BrandProfile.paidPartnershipList : getState().PublisherProfile.paidPartnershipList,
  fetchingActionType: entityType === 'brand' ? FETCH_BRAND_PARTNERSHIPS : FETCH_PUBLISHER_PARTNERSHIPS,
  fetchedActionType: entityType === 'brand' ? FETCHED_BRAND_PARTNERSHIPS : FETCHED_PUBLISHER_PARTNERSHIPS,
  apiCall: (filters) => entityType === 'brand' ?
    publishers.getBrandsPublishers(entityId, filters) :
    brands.getPublishersBrands(entityId, filters),
});

export const fetchPartnershipMetadata = (brandId, publisherId, entityType) => dispatch => {
  fetchPayload({
    dispatch,
    fetchingActionType: FETCH_PARTNERSHIP_METADATA,
    fetchedActionType: FETCHED_PARTNERSHIP_METADATA,
    apiCall: () => partnerships.getPartnershipMetadata(brandId, publisherId),
    fetchingPayload: { entityType },
  });
};

export const fetchPartnershipContent = (clear, brandId, publisherId) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().PartnershipProfile.partnershipContentList,
  fetchingActionType: FETCH_PARTNERSHIP_CONTENT,
  fetchedActionType: FETCHED_PARTNERSHIP_CONTENT,
  apiCall: (filters) => content.getPartnershipContent(brandId, publisherId, filters),
});

export const fetchPartnershipKeywords = (clear, brandId, publisherId) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  store: getState().KeywordsList.keywordsList,
  fetchingActionType: FETCH_KEYWORDS_LIST,
  fetchedActionType: FETCHED_KEYWORDS_LIST,
  apiCall: filters => keywords.getPartnershipKeywords(brandId, publisherId, filters),
});

export const fetchPartnershipCategories = (clear, brandId, publisherId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().CategoriesList.categoriesList,
    fetchingActionType: FETCH_CATEGORIES_LIST,
    fetchedActionType: FETCHED_CATEGORIES_LIST,
    apiCall: filters => categories.getPartnershipCategories(brandId, publisherId, filters),
  });
